exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.generated-outfit-container[data-v-3ed514dc] {\n  width: 100vw;\n  padding: 20px 13px;\n  min-height: 400px;\n}", ""]);

// exports
